import { client } from './client';
import { GP } from '../../const/apiPath';
import { AllGPResponseType } from '../models';

export const getAllGp = async (): Promise<AllGPResponseType> => {
  const { data } = await client.get(`${GP}`);
  return data;
};
